<template>
    <div class="mail-group-body bd bd-t-0 shadow-sm">
		<div v-for="(messages, index) in inbox">
            <label class="mail-group-label">{{ index }}</label>
            <ul v-for="(message, index) in messages" class="list-unstyled media-list mg-b-0">
                <router-link class="media" :class="message.status" :to="{ name: `messages.${type}.view`, params: { id: message.id} }">
					<div class="avatar">
						<span v-if="message.type === 'receive'" class="avatar-initial rounded-circle bg-warning">IC</span>
						<img v-else :src="message.client_details.avatar" class="rounded-circle" alt="">
					</div>
					<div class="media-body mg-l-15">
						<div class="tx-color-03 d-flex align-items-center justify-content-between mg-b-2">
							<span class="tx-12">{{ message.subject }}</span>
								<span class="tx-11">{{ message.created_at|toDate('LT') }}</span>
						</div>
						<h6 class="tx-13">{{ message.topic }}</h6>
						<p class="tx-12 tx-color-03 mg-b-0">{{ message.message|truncate(500) }}</p>
					</div>
				</router-link>
            </ul>
        </div>
    </div>
</template>

<style scoped>
	.mail-group-body {
		position: inherit;
	}

	.mail-group-body .media {
		padding: 15px 20px;
		background-color: #f8f9fc;
		cursor: pointer;
		transition: all 0.2s ease-in-out;
	}

	@media (prefers-reduced-motion: reduce) {
		.mail-group-body .media {
			transition: none;
		}
	}
	.mail-group-body .media:hover,
	.mail-group-body .media:focus {
		background-color: #f3f8ff;
	}
	.mail-group-body .media.unread,
	.mail-group-body .media.unread:hover,
	.mail-group-body .media.unread:focus {
		background-color: #fff;
	}
	.mail-group-body .media.selected,
	.mail-group-body .media.selected:hover,
	.mail-group-body .media.selected:focus {
		background-color: #ecf4ff;
	}
	.mail-group-body .media + .media {
		margin-top: -1px;
		border-top: 1px solid #e5e9f2;
	}
</style>

<script>
	export default {
		mounted() {},
		computed: {
			inbox() {
				return _.groupBy(this.messages, message => {
					const date = moment(message.updated_at, "YYYY-MM-DD").calendar(
						null,
						{
							sameDay: "[Today], MMM D",
							lastDay: "[Yesterday], MMM D",
							lastWeek: "[Last] dddd, MMM D",
							sameElse: "MMMM D YYYY"
						}
					);

					return date;
				});
			}
		},
		methods: {
			viewMessage(id) {
				this.$router.push({
					name: `messages.${this.type}.view`,
					params: { id: id }
				});
			}
		},
		props: ["messages", "type"]
	};
</script>